import React, {useState} from 'react'
import SubHeader from '../general/SubHeader'
import AboutImg from '../assets/about-img1.jpg';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import ScrollAnimation from 'react-animate-on-scroll';
import { MdArrowOutward } from 'react-icons/md';
import ChooseImg from '../assets/why-choose.jpg';
import { useNavigate } from 'react-router-dom';
import MyService from '../general/MyService';

const About = () => {
  const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("mission");

      const content = {
    mission: "Our platform is more than a collection of tools—it is a complete trading intelligence system designed to support disciplined decision-making, continuous learning, and measurable improvement. By combining news intelligence, market insights, education, analytics, and community, we help traders shift from reactive trading to strategic execution.",
    vision: "We believe that the key to profitable trading is self-awareness, discipline, and intelligent decision-making, and our platform is designed to make that simple, actionable, and insightful.",
    choose: "Trade Intell offers an intuitive and focused trade journaling experience designed for real traders. With powerful analytics, customizable trade tracking, and complete control over user-entered data, our platform helps traders identify patterns, validate strategies, and improve performance without complexity or unnecessary distractions."
  };


  return (
    <>
    <SubHeader message='About Us' />

    <section className='py-5'>
<div className='container'>

{/* <div className='row'> */}

{/* <div className='col-lg-6 col-12'>
<img src={AboutImg} className='img-fluid rounded w-100 h-100' alt='About' />
</div> */}

<div className='col-12 my-4' >
  <span className='fm-inter fw-semibold text-golden fs-5'>Measured trading leads to better results</span>
  <p className='mt-2 about-heading'>A Complete Trading Intelligence Platform Built for Consistent Performance</p>

<p className='para-text text-muted'>In today’s fast-moving financial markets, success is not driven by luck—it is driven by information, discipline, and execution. Our platform is designed to bring all three together in one powerful ecosystem, helping traders make well-informed decisions with confidence and precision.</p>

  <p className='para-text text-muted'>Over time, a comprehensive performance dashboard is generated, providing deep insights such as: -</p>

<div className='row'>
<div className='col-6'>
  <div className='bg-white rounded p-2 fw-semibold'>
    <IoMdCheckmarkCircleOutline size={38} className='text-golden' /> Overall and strategy-specific success rates</div></div>
<div className='col-6'><div className='bg-white rounded p-2 fw-semibold'>
  <IoMdCheckmarkCircleOutline size={38} className='text-golden' /> Risk management consistency</div></div>
</div>
{/* inner row ends */}

<p className='para-text text-muted mt-3'>Whether you are an active intraday trader, a swing trader, or a long-term market participant, our tools and insights are built to support your journey toward consistent and sustainable trading performance.</p>

</div>


{/* </div> */}
{/* row ends */}

</div>
</section>


{/* why choose */}
<section className='my-5'>
<div className='container'>


<div className='row'>


<div className='col-lg-6 col-12 my-2'>

<p className='border-bottom d-flex justify-content-between'>
     <p
                className={`choose-tab my-2 ${activeTab === "mission" ? "active" : ""}`}
                onClick={() => setActiveTab("mission")}
              >Our Mission</p>
     <p
                className={`choose-tab my-2 ${activeTab === "vision" ? "active" : ""}`}
                onClick={() => setActiveTab("vision")}
              >Our Vision</p>
     <p
                className={`choose-tab my-2 ${activeTab === "choose" ? "active" : ""}`}
                onClick={() => setActiveTab("choose")}
              >Why Choose Us?</p>
</p>

{activeTab == 'choose' && 
<button className='about-btn mb-3' onClick={() => navigate('/', { state: { scrollTo: 'comparison' } })}>Comparison- Trade Intell Vs. Other Platforms <MdArrowOutward size={20} /></button>
}

 <p className="text-muted para-text">
              {content[activeTab]}
            </p>

<p className='fm-inter fw-semibold'>{activeTab == 'mission' ?
'Trade With Knowledge. Execute With Precision. Grow With Discipline.'
: 'Start Your Professional Trading Experience Today 🚀'}
</p>
{activeTab != 'choose' && 
<button className='about-btn' onClick={() => navigate('/contact')}>Enquire Now <MdArrowOutward size={20} /></button>}

</div>


<div className='col-lg-6 col-12 my-2'>
    <img src={ChooseImg} className='img-fluid rounded-4 w-100' alt='About' />

</div>


</div>
{/* row ends */}

</div>
    </section>
{/* why choose ends */}


<MyService />

    </>
  )
}

export default About